import { render, staticRenderFns } from "./widget-announcement.vue?vue&type=template&id=41a06b32&scoped=true&"
import script from "./widget-announcement.vue?vue&type=script&lang=js&"
export * from "./widget-announcement.vue?vue&type=script&lang=js&"
import style0 from "./widget-announcement.vue?vue&type=style&index=0&id=41a06b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a06b32",
  null
  
)

export default component.exports